import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AttachedCandidateRef {
  candidateId: number;
  concernId: number;
}

export interface AttachExistingCandidatesByVerifiedEmailResponse
  extends BackendResponse {
  /** Total number of candidates matching the verified email (whether newly attached or already linked). */
  totalCandidates?: number;
  /** Candidate ids that were newly attached in this call. */
  newlyAttachedCandidateIds?: number[];
  /** All candidates matching the verified email, with the concern they belong to. */
  candidates?: AttachedCandidateRef[];
}

export interface AttachExistingCandidatesByVerifiedEmailParameters
  extends NextApiParams {
  email: string;
}

export const attachExistingCandidatesByVerifiedEmail = withNextApi<
  AttachExistingCandidatesByVerifiedEmailResponse,
  AttachExistingCandidatesByVerifiedEmailParameters
>("/auth/AttachExistingCandidatesByVerifiedEmail");
